import { useContext, useEffect, useState } from "react"
import { ReservationI } from "types/ReservationsI"

import SCSS from 'assets/scss/Reservations.module.scss'
import Loader from "./Loader"
import { ResponseError } from "types/responses/ResponseError"
import { PageType } from "types/PageI"
import getUserReservations from "services/user_services/GetUserReservations"
import getUserReservationsHistory from "services/user_services/GetUserReservationsHistory"
import PageContext from "global_state/context/PageContext"
import Title from "./Title"
import { lessonCancelReservationService } from "services/LessonsServices"

import content from 'languages/Reservations.json'
import UserContext from "global_state/context/UserContext"
import { BiChevronDown, BiX } from "react-icons/bi"

function Reservations() {

    const {page, dispatchPage} = useContext(PageContext)
    const {user} = useContext(UserContext)
    let lang = page.settings.language

    const [reservations_response, setReservationsResponse] = useState<string | ReservationI[]>()
    const [reservations_history_response, setReservationHistoryResponse] = useState<string | ReservationI[]>()

    const handleGoToShedule = () => {
        dispatchPage({type: "render", payload: {page: PageType.lessons}})
    }

    const [active_reservation_opened, setActiveReservationOpened] = useState<boolean>(false)
    const [history_reservation_opened, setHistoryReservationOpened] = useState<boolean>(false)

    useEffect(() => {
        const getReservations = async () => {
            setReservationsResponse(await getUserReservations(user.client_id))
        }
        const getHistoryReservations = async() => {
            setReservationHistoryResponse(await getUserReservationsHistory(user.client_id, 1, 40))
        }

        getReservations()
        getHistoryReservations()
    }, [])

    useEffect(() => {
        // console.log(reservations_response);
        
    }, [reservations_response])

    useEffect(() => {
        // console.log(reservations_history_response);
        
    }, [reservations_history_response])

    if (!(reservations_response)) {
        return <Loader/>
    }

    if (typeof reservations_response === 'string') {
        return <Loader error={ResponseError.general_error}/>
    }

    const renderReservations = reservations_response.map((reservation, index) => {
        return (
            <Reservation key={index} index={index} reservation={reservation} language={lang} actual={true}/>
        )
    })

    const renderHistoryReservations = () => {
        
        
        if (reservations_history_response == undefined || typeof reservations_history_response === 'string' 
            ||reservations_history_response.length == 0) {
            return content[lang].history_reservation_placeholde
        }
        return reservations_history_response.map((reservation, index) => {
            return (
                <Reservation key={index} index={index} reservation={reservation} language={lang} actual={false}/>
            )
        })
    }
    
 
    const renderActiveIocn = (type:string) => {
        if (type === 'active') {
            if (active_reservation_opened) {
                return  <BiX/>
            }
            return <BiChevronDown/>
        }


        if (type === 'history') {
            if (history_reservation_opened) {
                return  <BiX/>
            }
            return <BiChevronDown/>
        }
    }


    return (
        <div className={SCSS.reservations}>
            <Title back_arrow={true} title={content[lang].title} />
            <div className={SCSS.new_reservation}>
                {/* <h4>{content[lang].new_reservation}</h4> */}
                <div className={SCSS.rules}>
                    <a href={content[lang].rules_link}>
                        {content[lang].rules_text}
                    </a>
                </div>
                <button className={SCSS.to_schedule} onClick={handleGoToShedule}>{content[lang].to_schedule}</button>
            </div>
            
            <div className={SCSS.info}>{content[lang].reservation_info}</div>
            <div className={SCSS.active}>
                <h4 onClick={() => {
                    setActiveReservationOpened(active => !active)
                }} className={SCSS.dropdown}>
                    <span className={SCSS.name}>{content[lang].active_reservation}</span>
                    <span className={SCSS.icon}>{renderActiveIocn('active')}</span>
                </h4>
                <div className={[SCSS.reservationsWrap, (active_reservation_opened? "": SCSS.hide)].join(" ")}>
                    {reservations_response.length > 0 ? renderReservations: content[lang].active_reservation_placeholde}
                </div>
            </div>


            <div className={SCSS.history}>
                <h4 onClick={() => {
                    setHistoryReservationOpened(active => !active)
                }} className={SCSS.dropdown}>
                    <span className={SCSS.name}>{content[lang].history_reservation}</span>
                    <span className={SCSS.icon}>{renderActiveIocn('history')}</span>
                </h4>
                <div className={[SCSS.reservationsWrap, (history_reservation_opened? "":SCSS.hide)].join(" ")}>
                    {renderHistoryReservations()}
                </div>
            </div>
            
        </div>
    )
}


interface ReservationProps {
    reservation: ReservationI
    index: number,
    actual: boolean,
    language: any
}
function Reservation(props: ReservationProps) {
    const renderDate = (date:Date | null) => {
        if (!date) {
            return null
        }
        let year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        let day = date.getUTCDate()
        let minutes = date.getUTCMinutes().toString();
        if(minutes == "0")
            minutes = "00";
        
        return (
            <span>{day}.{month}.{year} {date.getUTCHours()}:{minutes}</span>
        )
    }

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [fee, setFee] = useState<null | number>(null)

    const cancelReservationClick = () => {
        setLoading(true);
        setError("");
        lessonCancelReservationService(props.reservation.lesson_id).then(data  => {
            if ('fee' in data) 
                setFee(data.fee)
            if ('error' in data)
                setError(data.error);
            setLoading(false);
        }).catch(error => {
            // console.log(error);
            setLoading(false);
        });
    }
    const renderError = () => {
        if(error == "")
            return "";
        return (<div className={SCSS.error}>{error}</div>);
    }

    const renderFooter = () => {
        if(!props.actual)
            return "";
        if(loading)
            return ( 
                <div className={SCSS.footer}>
                    <button className={SCSS.loading_button}><Loader /></button>
                </div>
            );
        if(fee != null)
            return ( 
                <div className={SCSS.footer}>
                    <div className={SCSS.success}>{content[props.language].reservation_was_cancelled} {fee} Kč</div>
                </div>
            );
        return ( 
            <div className={SCSS.footer}>
                {error ? renderError() : ""}
                <button className={SCSS.cancel_reservation}  onClick={() => cancelReservationClick()}>{content[props.language].cancel_reservation}</button>
            </div>
        );
    }


    return (
        <div key={props.index} className={SCSS.reservation}>
            
            <div className={SCSS.reservationDate}>
                {renderDate(props.reservation.date)} ({props.reservation.length} {content[props.language].minutes})
            </div>
            <div className={SCSS.reservationName}>
                {props.reservation.name}                          
            </div>
            <div className={SCSS.reservationDesc}>
                {props.reservation.description}
            </div>     

            {renderFooter()}
        </div>
    )
}

export default Reservations